import { Image } from 'components/elements/image/Image';
import { usePolyglotT } from 'utils/locale/locale';
import { useMyTheme } from 'themes/helpers';
import { useViewport, Viewport } from 'hooks/use-viewport/use-viewport';
import { LogoWrapper } from './LogoImage.styles';

export const LogoImage = () => {
  const { locale, t } = usePolyglotT();
  const { type } = useMyTheme();
  const viewport: Viewport = useViewport();

  const imageSizes = {
    mobile: { width: 165, height: 17 },
    tablet: { width: 224, height: 23 },
    desktop: { width: 224, height: 23 },
  };

  const { width, height } = imageSizes[viewport];

  const telusOne =
    type === 'dark' ? '/telus-health-one-dark.svg' : '/telus-health-one.svg';

  const telusSante =
    type === 'dark' ? '/telus-sante-dark.svg' : '/telus-sante.svg';

  const getLogoFromLocale =
    locale && locale.split('_')[0] === 'fr' ? telusSante : telusOne;

  return (
    <LogoWrapper>
      <Image
        data-testid={getLogoFromLocale}
        src={`${getLogoFromLocale}`}
        alt={t('header.logo_alt')}
        width={width}
        height={height}
        priority={true}
      />
    </LogoWrapper>
  );
};
